import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "analytic-head__row" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "analytic-head__row" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "analytic-head__title" }, "Bot status:"),
    /*#__PURE__*/_createElementVNode("span", { class: "analytic-head__value analytic-head__status analytic-head__status--active" }, "Active")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "analytic-head__row" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "analytic-head__title" }, "Actual price:"),
    /*#__PURE__*/_createElementVNode("span", {
      class: "analytic-head__value analytic-head__course",
      "data-currency": "USDT/BTC"
    }, "69 425.22")
  ])
], -1)
const _hoisted_2 = { class: "section section--mini" }

import "./AnalyticView.scss";

import Hat from "@/components/Hat/Hat.vue";
import AnalyticChart from "@/components/AnalyticChart/AnalyticChart.vue";
import TradingHistory from "@/components/TradingHistory/TradingHistory.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyticView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Hat, { class: "analytic-head section section--mini screen-start" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(TradingHistory)
    ])
  ], 64))
}
}

})